import { useQuery } from "react-query";
import { getSubscriptions } from "../api/plans/getSubscriptions";

export const useQuerySubscriptions = () =>
  useQuery("subscriptions", getSubscriptions);
